export default function () {
  return {
    redirects: [],
    showDeleteDialog: false,
    deletingId: null,
  }
}
